import { Navigate, useLocation } from 'react-router-dom';
import { getSigninRedirectPath } from '../../helpers/getSigninRedirectPath';

export const RedirectToSignin = () => {
  const location = useLocation();

  return <Navigate to={getSigninRedirectPath(location)} replace />;
};
